import { applyFormat } from "components/ui/ui-helpers";

export const ApplySignedFormat = (value, unit = " €", precision=0) => {
  const dataType = precision > 0 ? "decimal" : "int";
  if (Number(value) > 0) {
    return "+ " + applyFormat(value, dataType, { thousands: " ", decimal: ",", unit, precision });
  }
  return applyFormat(value, dataType, { thousands: " ", decimal: ",", unit, precision });
};
